import green from './green.png';
import lavender from './lavender.png';
import night from './night.png';
import orange from './orange.png';
import yellow from './yellow.png';

// Choose random default image when one is not provided with Contentful data
const defaultImageOptions = [green, lavender, night, orange, yellow];

export const defaultImage = () =>
  defaultImageOptions[Math.floor(Math.random() * defaultImageOptions.length)];
